import { useEffect, useState } from "react"

import { describeFAQs, fetchFAQs } from "../services/api"
import { useAosOnContent, useAsyncData } from "./useAsyncData"

export const useFAQPreview = (pageSize = 12) => {
    const { data: description, loading: descriptionLoading } = useAsyncData(
        () => describeFAQs().then(({ data }) => data),
        [pageSize]
    )

    const { data: faqs, loading: faqsLoading } = useAsyncData(
        () => fetchFAQs(1, pageSize).then(({ data }) => data.faqs || []),
        [pageSize]
    )

    return {
        faqs: faqs || [],
        totalFaqs: description?.faqs ?? 0,
        loading: descriptionLoading || faqsLoading,
    }
}

export const usePaginatedFAQs = (pageSize = 8, searchQuery = "") => {
    const [currentPage, setCurrentPage] = useState(1)
    const normalizedQuery = searchQuery.trim()

    useEffect(() => {
        setCurrentPage(1)
    }, [normalizedQuery, pageSize])

    const { data: description, loading: descriptionLoading } = useAsyncData(
        () => describeFAQs(normalizedQuery).then(({ data }) => data),
        [pageSize, normalizedQuery]
    )

    const totalFaqs = description?.faqs ?? 0
    const totalPages = Math.max(1, Math.ceil(totalFaqs / pageSize))

    const { data: faqs, loading: faqsLoading } = useAsyncData(
        () =>
            fetchFAQs(currentPage, pageSize, normalizedQuery).then(
                ({ data }) => data.faqs || []
            ),
        [currentPage, pageSize, normalizedQuery]
    )

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages)
        }
    }, [currentPage, totalPages])

    useEffect(() => {
        if (currentPage > 1) {
            window.scrollTo({ top: 0, behavior: "smooth" })
        }
    }, [currentPage])

    useAosOnContent(faqs)

    return {
        faqs: faqs || [],
        totalFaqs,
        currentPage,
        setCurrentPage,
        totalPages,
        loading: descriptionLoading || faqsLoading,
        searchQuery: normalizedQuery,
    }
}
